<template>
  <tr class="group">
    <td
      class="w-px border-b border-l border-gray-400 bg-white p-4 align-middle group-last:rounded-bl-lg"
    >
      <nuxt-link
        :to="'/products/' + item.merchandise.product.handle"
        class="block w-32 overflow-hidden rounded border border-gray-200 transition-colors hover:border-gray-500"
      >
        <img
          :src="item.merchandise.image.urlThumbnail"
          class="block max-w-full rounded"
        ></nuxt-link>
    </td>
    <th
      class="border-b border-gray-400 bg-white py-6 pl-6 text-left align-middle font-normal lg:py-2"
    >
      <p>
        <nuxt-link
          :to="'/products/' + item.merchandise.product.handle"
          class="text-md mb-0.5 inline-block font-bold leading-tight lg:text-lg"
        >{{ item.merchandise.product.title }}</nuxt-link>
      </p>
      <!-- <p class="text-xs">{{ item.id }}</p> -->
      <table class="mb-3 table-auto lg:mb-0">
        <tbody>
          <tr
            v-for="option in item.merchandise.selectedOptions"
            :key="option.name"
          >
            <th class="pr-3 text-sm leading-snug tracking-wide">
              {{ option.name }}:
            </th>
            <td class="text-sm leading-snug tracking-wide">
              {{ option.value }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="mb-3 flex flex-row lg:hidden">
        <div class="flex-1 md:flex-none">
          dfdf
          <!-- <NumberSpinner
            v-model="tempQuantity"
            :minVal="0"
            :maxVal="5000"
            size="sm"
            :disabled="updatingQuantity"
            class="block w-full md:w-56"
          /> -->
        </div>

        <!-- <div
          @click="deleteItem"
          class="flex cursor-pointer items-center justify-center pl-4 pr-4 opacity-75 transition-opacity hover:opacity-100"
        >
          <span class="block"
            ><ClientOnly
              ><font-awesome-icon
                :icon="['fas', 'trash-can']"
              ></font-awesome-icon></ClientOnly
          ></span>
        </div> -->
      </div>

      <p class="text-sm lg:hidden">
        <span class="mr-1 inline-block font-bold">Total:</span><span class="font-mono">{{ totalPrice
        }}</span>
      </p>
    </th>

    <td
      class="hidden w-px border-b border-gray-400 bg-white pl-6 align-middle lg:table-cell lg:py-2"
    >
      <FormNumberSpinner
        v-model="itemQuantity"
        size="md"
        min="0"
        max="1000"
        class="min-w-44"
      />

      <!-- <NumberSpinner
        v-model="tempQuantity"
        :minVal="0"
        :maxVal="5000"
        :disabled="updatingQuantity"
        class="block w-56"
      /> -->
    </td>

    <td
      class="hidden w-px border-b border-gray-400 bg-white pl-4 lg:table-cell"
    >
      <UButton
        icon="i-fa6-solid-xmark"
        color="gray"
        variant="outline"
        class="opacity-30 hover:opacity-100"
        size="md"
        square
        @click="onRemove"
      />
    </td>

    <td
      class="hidden w-px border-b border-r border-gray-400 bg-white p-8 text-right align-middle text-lg text-sm group-last:rounded-br-lg lg:table-cell"
    >
      <span class="block w-36">
        {{ totalPrice }}
      </span>
    </td>
  </tr>
</template>

<script setup lang="ts">
const store = useStore()
const { currentCountry } = storeToRefs(store)

const props = defineProps(["item"])

const { item } = toRefs(props)

const onRemove = async () => {
  await updateQuantity(0)
}

const itemQuantity = ref(item.value.quantity)

const totalPrice = computed(() =>
  formatPrice(
    item?.value.cost.totalAmount.amount,
    currentCountry.value.isoCode,
    currentCountry.value.currency.isoCode,
  ),
)

const updateQuantity = async (quantity) => {
  const cartLine = {
    id: item.value.id,
    merchandiseId: item.value.merchandise.id,
    quantity,
  }

  await store.updateCart([cartLine])
}

watch(itemQuantity, async (newVal) => {
  if (Number(newVal) === 0) {
    await sleep(500)
    await updateQuantity(Number(itemQuantity.value))
  }
  else {
    await updateQuantity(Number(itemQuantity.value))
  }
})
</script>
